import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";
import { NSColumn, NSTabPage, NSTitle } from "namirasoft-site-react";

interface KubernetesViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class KubernetesViewPage extends Component<KubernetesViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.kubernetes(this.props),
                    view: {
                        ui: {
                            getChildrenAfter: (_, row) => row.agent_pod_installation_enabled
                                ?
                                (
                                    <NSColumn classList={["my-4"]}>
                                        <NSTitle title="Install" />
                                        <NSTabPage
                                            tabs={[
                                                {
                                                    title: "Helm",
                                                    clicked: true,
                                                    getContent: () => <></>
                                                },
                                                {
                                                    title: "Yaml",
                                                    clicked: true,
                                                    getContent: () => <></>
                                                }
                                            ]}
                                        />
                                    </NSColumn>
                                )
                                : <></>
                        }
                    }
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}